import { render } from "./ValidationTable.vue?vue&type=template&id=40a4c5db&scoped=true&ts=true"
import script from "./ValidationTable.vue?vue&type=script&lang=ts"
export * from "./ValidationTable.vue?vue&type=script&lang=ts"

import "./ValidationTable.vue?vue&type=style&index=0&id=40a4c5db&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a4c5db"]])

export default __exports__